const Maintenance = () => {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100 px-4">
      <div className="text-center max-w-md">
        <h1 className="text-3xl font-bold text-gray-800 mb-3">
          🚧 Under Maintenance
        </h1>
        <p className="text-gray-600 mb-6">
          Our servers are currently unavailable.  
          We’re working hard to get things back online.
        </p>
        <span className="text-sm text-gray-500">
          Please check back again soon.
        </span>
      </div>
    </div>
  );
};

export default Maintenance;